import { combineReducers } from 'redux'

import { surveyProfile } from './survey'

export const surveyReducer = combineReducers({
  surveyProfile
})
